import { useEffect, useState } from "react";
import "../AddUserRights/AddUserRights.scss";
import AddUserRowsCol from "./AddUserRowsCol";

const UserRightsRows = ({ data, handleEdit, allTick }) => {
  // const {_id,page,Master_Name,Modules,Page_Access,Is_Add,Is_Edit,Is_View,Is_Delete,Export,Audit,UnAudit} = data;
  const {
    _id,
    Page_Name,
    Page_Access,
    Is_Add,
    Is_Edit,
    Is_View,
    Is_Delete,
    Export,
    Is_Lock,
    Is_Unlock,
    Audit,
    UnAudit,
  } = data.Page;
  const [init, setInit] = useState({
    _id: _id,
    Page_Access: Page_Access,
    Is_Add: Is_Add,
    Is_Edit: Is_Edit,
    Is_View: Is_View,
    Is_Delete: Is_Delete,
    Export: Export,
    Is_Lock,
    Is_Unlock,
    Audit: Audit,
    UnAudit: UnAudit,
  });
  // const [dataArr,setDataArr] = useState([])
  const [count, setCount] = useState(0);

  useEffect(() => {
    setInit({
      _id: _id,
      Page_Access: Page_Access,
      Is_Add: Is_Add,
      Is_Edit: Is_Edit,
      Is_View: Is_View,
      Is_Delete: Is_Delete,
      Export: Export,
      Is_Lock,
      Is_Unlock,
      Audit: Audit,
      UnAudit: UnAudit,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleChange = ({ name, checked }) => {
    setInit((prev) => {
      return {
        ...prev,
        [name]: checked,
      };
    });
    if (name === "Page_Access" && checked === false) {
      setInit((prev) => {
        return {
          ...prev,
          Is_Add: false,
          Is_Edit: false,
          Is_View: false,
          Is_Delete: false,
          Export: false,
          Is_Lock: false,
          Is_Unlock: false,
          Audit: false,
          UnAudit: false,
        };
      });
      handleEdit(_id, { name: "Is_Add", checked: false });
      handleEdit(_id, { name: "Is_Edit", checked: false });
      handleEdit(_id, { name: "Is_View", checked: false });
      handleEdit(_id, { name: "Is_Delete", checked: false });
      handleEdit(_id, { name: "Is_Merge", checked: false });
      handleEdit(_id, { name: "Export", checked: false });
      handleEdit(_id, { name: "Is_Lock", checked: false });
      handleEdit(_id, { name: "Is_Unlock", checked: false });
      handleEdit(_id, { name: "Audit", checked: false });
      handleEdit(_id, { name: "UnAudit", checked: false });
    }
    handleEdit(_id, { name, checked });
  };

  let dataArr = [
    {
      checked: init.Page_Access,
      name: "Page_Access",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_Add,
      disabled: init.Page_Access === false,
      name: "Is_Add",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_Edit,
      disabled: init.Page_Access === false,
      name: "Is_Edit",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_View,
      disabled: init.Page_Access === false,
      name: "Is_View",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_Delete,
      disabled: init.Page_Access === false,
      name: "Is_Delete",
      func: (e) => handleChange(e.target),
    },

    {
      checked: init.Export,
      disabled: init.Page_Access === false,
      name: "Export",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_Lock,
      disabled: init.Page_Access === false,
      name: "Is_Lock",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Is_Unlock,
      disabled: init.Page_Access === false,
      name: "Is_Unlock",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.Audit,
      disabled: init.Page_Access === false,
      name: "Audit",
      func: (e) => handleChange(e.target),
    },
    {
      checked: init.UnAudit,
      disabled: init.Page_Access === false,
      name: "UnAudit",
      func: (e) => handleChange(e.target),
    },
  ];

  useEffect(() => {
    if (count !== 0) {
      if (allTick.Is_Add === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Add: true,
          };
        });
        handleEdit(_id, { name: "Is_Add", checked: true });
      } else if (allTick.Is_Add === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Add: false,
          };
        });
        handleEdit(_id, { name: "Is_Add", checked: false });
      }
      if (allTick.Page_Access === true) {
        setInit((prev) => {
          return {
            ...prev,
            Page_Access: true,
          };
        });
        handleEdit(_id, { name: "Page_Access", checked: true });
      } else if (allTick.Page_Access === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Page_Access: false,
          };
        });
        handleEdit(_id, { name: "Page_Access", checked: false });
      }
      if (allTick.Is_Edit === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Edit: true,
          };
        });
        handleEdit(_id, { name: "Is_Edit", checked: true });
      } else if (allTick.Is_Edit === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Edit: false,
          };
        });
        handleEdit(_id, { name: "Is_Edit", checked: false });
      }
      if (allTick.Is_View === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_View: true,
          };
        });
        handleEdit(_id, { name: "Is_View", checked: true });
      } else if (allTick.Is_View === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_View: false,
          };
        });
        handleEdit(_id, { name: "Is_View", checked: false });
      }
      if (allTick.Is_Delete === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Delete: true,
          };
        });
        handleEdit(_id, { name: "Is_Delete", checked: true });
      } else if (allTick.Is_Delete === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Delete: false,
          };
        });
        handleEdit(_id, { name: "Is_Delete", checked: false });
      }

      if (allTick.Export === true) {
        setInit((prev) => {
          return {
            ...prev,
            Export: true,
          };
        });
        handleEdit(_id, { name: "Export", checked: true });
      } else if (allTick.Export === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Export: false,
          };
        });
        handleEdit(_id, { name: "Export", checked: false });
      }

      if (allTick.Is_Lock === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Lock: true,
          };
        });
        handleEdit(_id, { name: "Is_Lock", checked: true });
      } else if (allTick.Is_Lock === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Lock: false,
          };
        });
        handleEdit(_id, { name: "Is_Lock", checked: false });
      }
      if (allTick.Is_Unlock === true) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Unlock: true,
          };
        });
        handleEdit(_id, { name: "Is_Unlock", checked: true });
      } else if (allTick.Is_Unlock === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Is_Unlock: false,
          };
        });
        handleEdit(_id, { name: "Is_Unlock", checked: false });
      }

      if (allTick.Audit === true) {
        setInit((prev) => {
          return {
            ...prev,
            Audit: true,
          };
        });
        handleEdit(_id, { name: "Audit", checked: true });
      } else if (allTick.Audit === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            Audit: false,
          };
        });
        handleEdit(_id, { name: "Audit", checked: false });
      }
      if (allTick.UnAudit === true) {
        setInit((prev) => {
          return {
            ...prev,
            UnAudit: true,
          };
        });
        handleEdit(_id, { name: "UnAudit", checked: true });
      } else if (allTick.UnAudit === false || allTick.Page_Access === false) {
        setInit((prev) => {
          return {
            ...prev,
            UnAudit: false,
          };
        });
        handleEdit(_id, { name: "UnAudit", checked: false });
      }
    }
    setCount(3);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allTick]);
  return (
    <tr className="table-row">
      <td class="table-data">
        <p>{Page_Name}</p>
      </td>
      <td class="table-data">
        <p>{data.Master_Name}</p>
      </td>
      <td class="table-data">
        <p>{data.Module_Name}</p>
      </td>
      {dataArr &&
        dataArr.length > 0 &&
        dataArr.map((el) => (
          <AddUserRowsCol checked={el.checked} disabled={el.disabled} name={el.name} func={el.func} />
        ))}
      {/* <td class="table-data" >{<AiFillDelete size={"1.5em"}/>}</td> */}
    </tr>
  );
};

export default UserRightsRows;
